import Header from "../../component/Header";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import noImage from "../../images/errors.png";
import { Oval } from "react-loader-spinner";
import OtherProducts from "./component/OtherProducts";
import ScreenAdmin from "./ScreenAdmin";
import Sidebar from "../../component/Sidebar";
import EthioProducts from "../Ethio/EthioProducts";

const apiUrl = process.env.REACT_APP_API_URL;

function Admin() {
  const userId = localStorage.getItem("token");
  const [zoom, setZoom] = useState(1);
  const [totalPrice, setTotalPrice] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterDay, setFilterDay] = useState("");
  const [filterStatusP, setFilterStatusP] = useState("");
  const [filterModel, setFilterModel] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [imageFile1, setImageFile1] = useState(null); // For the fir st image
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [totalSent, setTotalSent] = useState("");
  const [totalReceivedCal, setTotalReceivedCal] = useState("");
  const [totalOrder, setTotalOrder] = useState("");
  const [totalCarrier, setTotalCarrier] = useState("");
  const [sortBy, setSortBy] = useState("orderNumber"); // Default sorting

  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Added for year filter

  let totalYuanSum = 0;
  let totalProfit = 0;
  let totalBirrSum = 0;
  let totalBirrCarrier = 0;

  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = (imageUrls) => {
    setImages(imageUrls);
    setCurrentIndex(0); // Start from the first image
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedImage("");
  };

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const dropdownRef = useRef(null);
  // Define short forms for months
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get current month in short form
  const getCurrentMonthShortForm = () => {
    const monthIndex = new Date().getMonth();
    return months[monthIndex];
  };

  const sortByModelName = (data) => {
    return [...data].sort((a, b) => a.Model.localeCompare(b.Model));
  };

  const sortByOrderNumber = (data) => {
    return [...data].sort((a, b) => {
      const [aMonth, aNumber] = [
        a.OrderNumber.slice(0, 3),
        parseInt(a.OrderNumber.slice(3), 10),
      ];
      const [bMonth, bNumber] = [
        b.OrderNumber.slice(0, 3),
        parseInt(b.OrderNumber.slice(3), 10),
      ];
      return aMonth !== bMonth
        ? bMonth.localeCompare(aMonth)
        : bNumber - aNumber;
    });
  };

  const applySorting = (data, sortBy) => {
    switch (sortBy) {
      case "model":
        return sortByModelName(data);
      case "orderNumber":
        return sortByOrderNumber(data);
      default:
        return data; // No sorting applied
    }
  };

  const filterDataByMonth = (data, month) => {
    return data.filter((item) => item.OrderNumber.startsWith(month));
  };

  const filterDataByYear = (data, year) => {
    return data.filter((item) => {
      const itemYear = new Date(item.TimeStamp).getFullYear();
      return itemYear === parseInt(year, 10);
    });
  };

  const applyFilters = (data, month, year) => {
    let filtered = filterDataByYear(data, year);
    filtered = filterDataByMonth(filtered, month);
    return filtered;
  };

  const currentMonthShortForm = () => {
    const monthIndex = new Date().getMonth(); // Get current month index (0-11)
    return months[monthIndex];
  };
  const [selectedMonth, setSelectedMonth] = useState(currentMonthShortForm());

  const filterByMonthAll = (month = getCurrentMonthShortForm()) => {
    setSelectedMonth(month);
    const filteredMonth = data.filter((item) =>
      item.OrderNumber.startsWith(month)
    );
    const filteredYear = filterDataByYear(filteredMonth, selectedYear);
    setFilteredData(filteredYear);
    const filtered = applyFilters(data, month, selectedYear);
    setFilteredData(filtered);
    const sum = filteredMonth.reduce(
      (acc, item) => acc + parseFloat(item.Price || 0),
      0
    );
    const carrierSum = filteredMonth.reduce(
      (acc, item) => acc + parseFloat(item.Carrier || 0),
      0
    );
    const receivedTotal = filteredMonth.filter(
      (item) => item.Status === "Received"
    ).length;
    const sentTotal = filteredMonth.filter(
      (item) => item.Status === "Sent"
    ).length;
    const ordered = filteredMonth.length;

    setTotalPrice(sum);
    setTotalReceivedCal(receivedTotal);
    setTotalSent(sentTotal);
    setTotalOrder(ordered);
    setTotalCarrier(carrierSum);
  };

  // Fetch data from API and apply initial filter by month
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/items`);
      const fetchedData = response.data.map((item) => ({
        ...item,
        imageUrl1: `${apiUrl}/uploads/${item.ImageFilename1}`,
        imageUrl2: `${apiUrl}/uploads/${item.ImageFilename2}`,
      }));
      const sortedData = applySorting(fetchedData, sortBy);
      setData(sortedData);
      setFilteredData(applyFilters(sortedData, selectedMonth, selectedYear));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  // const handleMonthChange = (event) => {
  //   const month = event.target.value;
  //   setSelectedMonth(month);
  //   setFilteredData(filterDataByMonth(data, month));
  // };

  const updateStatus = async (itemId, ourStat) => {
    try {
      setLoading(true);
      const res = await axios.put(
        `${apiUrl}/updateOurStat`,
        {
          id: itemId,
          ourStat,
        },
        {
          headers: {
            Authorization: `Bearer ${userId}`,
          },
        }
      );

      fetchData();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handleOptionSelect = (index, itemId, ourStat) => {
    setDropdownOpen(null); // Close the dropdown
    // Update the status in the frontend
    setData(
      data.map((item) =>
        item.ID === itemId ? { item, ourStat: ourStat } : item
      )
    );
    // Update the status in the backend
    updateStatus(itemId, ourStat);
    // fetchData();
  };

  const filterByMonthAndYear = (
    month = currentMonthShortForm(),
    year = new Date().getFullYear()
  ) => {
    setSelectedMonth(month);
    setSelectedYear(year);
    const filtered = applyFilters(data, month, year);
    setFilteredData(filtered);

    const sum = filtered.reduce(
      (acc, item) => acc + parseFloat(item.Price || 0),
      0
    );
    const carrierSum = filtered.reduce(
      (acc, item) => acc + parseFloat(item.Carrier || 0),
      0
    );
    const receivedTotal = filtered.filter(
      (item) => item.Status === "Received"
    ).length;
    const sentTotal = filtered.filter((item) => item.Status === "Sent").length;
    const ordered = filtered.length;

    setTotalPrice(sum);
    setTotalReceivedCal(receivedTotal);
    setTotalSent(sentTotal);
    setTotalOrder(ordered);
    setTotalCarrier(carrierSum);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    filterByMonthAndYear(selectedMonth, year);
  };

  const handleMonthChange = (event) => {
    const month = event.target.value;
    filterByMonthAndYear(month, selectedYear);
  };
  useEffect(() => {
    fetchData(sortBy);
  }, [sortBy, selectedYear]);

  const toggleDropdown = (index) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [initialData, setInitialData] = useState({}); // Store the initial row data when editing starts

  const [isEditing, setIsEditing] = useState(null);
  const [editData, setEditData] = useState({
    brand: "",
    model: "",
    sim: "",
    ram: "",
    storage: "",
    status: "",
    delivery: "",
    price: "",
    com1: "",
    com2: "",
    rate: "",
    carrier: "",
    buyer: "",
    seller: "",
    soldPrice: "",
    receiver: "",
    salesDate: "",
    buyRate: "",
    payments: [],
  });

  const handleEditClick = (item) => {
    setIsEditing(item.ID);
    setInitialData({
      brand: item.Brand,
      model: item.Model,
      sim: item.Sim,
      ram: item.Ram,
      storage: item.Storage,
      status: item.Status,
      delivery: item.DeliveryFee,
      price: item.Price, // Add image URL to initial data
      com1: item.com1, // Add image URL to initial data
      com2: item.com2, // Add image URL to initial data
      rate: item.rate, // Add image URL to initial data
      carrier: item.carrier, // Add image URL to initial data
      buyer: item.buyer, // Add image URL to initial data
      seller: item.seller, // Add image URL to initial data
      soldPrice: item.soldPrice, // Add image URL to initial data
      receiver: item.receiver, // Add image URL to initial data
      salesDate: item.salesDate, // Add image URL to initial data
      buyRate: item.buyRate, // Add image URL to initial data
      payments: item.payments || [],
    });
    setEditData({}); // Start with an empty object
    setImageFile1(null);
    setImageFile1(null); // Start with no image
  };
  const [editImage1, setEditImage1] = useState(null);
  const [editImage2, setEditImage2] = useState(null);

  // Handle changes to text fields
  const handleChange = (field, value) => {
    setEditData((prev) => ({
      ...prev,
      [field]: value !== initialData[field] ? value : undefined, // Set value if changed, otherwise undefined
    }));
  };

  const handlePaymentChange = (index, field, value) => {
    setEditData((prev) => {
      const updatedPayments = [
        ...(prev.payments || initialData.payments || []),
      ];
      updatedPayments[index] = { ...updatedPayments[index], [field]: value };
      return { ...prev, payments: updatedPayments };
    });
  };

  const addPayment = (type = "bank") => {
    setEditData((prev) => ({
      ...prev,
      payments: [
        ...(prev.payments || []),
        type === "bank"
          ? { type: "bank", account: "", amount: "" }
          : { type: "item", description: "", value: "" },
      ],
    }));
  };

  const removePayment = (index) => {
    setEditData((prev) => {
      const updatedPayments = [...(prev.payments || [])];
      updatedPayments.splice(index, 1);
      return { ...prev, payments: updatedPayments };
    });
  };

  // Function to handle saving the edited data
  const handleSave = async (id) => {
    try {
      setLoading(true);
      const completeEditData = createFormData();

      // Append image files if they are selected
      appendImages(completeEditData);

      // Make the PUT request
      const response = await axios.put(
        `${apiUrl}/updateItem/${id}`,
        completeEditData,
        {
          headers: {
            Authorization: `Bearer ${userId}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setData(data.map((item) => (item.ID === id ? response.data : item)));
      setIsEditing(null);
      setLoading(false);
      setEditImage1(null);
      setEditImage2(null);
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const createFormData = () => {
    const completeEditData = new FormData();

    const fields = [
      "brand",
      "model",
      "sim",
      "ram",
      "price",
      "storage",
      "status",
      "delivery",
      "com1",
      "com2",
      "carrier",
      "rate",
      "buyRate",
      "seller",
      "buyer",
      "receiver",
      "soldPrice",
      "salesDate",
      "payments",
    ];

    fields.forEach((field) => {
      let value =
        editData[field] !== undefined ? editData[field] : initialData[field];

      if (field === "payments" && value) {
        value = JSON.stringify(value); // 👈 stringify before appending
      }

      completeEditData.append(field, value ?? "");
    });

    return completeEditData;
  };

  const appendImages = (formData) => {
    if (editImage1) {
      formData.append("images", editImage1); // First image
    }
    if (editImage2) {
      formData.append("images", editImage2); // Second image
    }
  };

  const filterByDay = (data) => {
    if (!filterDay) return data;
    return filteredData.filter((item) => {
      const itemDate = new Date(item.salesDate);
      const itemDay = itemDate.getDate();
      return itemDay === parseInt(filterDay, 10);
    });
  };

  const filterByStatus = (data) => {
    if (filterStatusP === "" || filterStatusP === "__all__") return data; // show all if not selected
    if (filterStatusP === "__unreceived__") {
      return data.filter((item) => !item.ourStat); // only empty ourStat
    }
    return data.filter((item) => item.ourStat === filterStatusP);
  };

  const filterByModel = (data) => {
    if (!filterModel) return data;
    return filteredData.filter(
      (item) =>
        item.Model &&
        item.Model.toLowerCase().includes(filterModel.toLowerCase())
    );
  };

  // Apply all filters in useEffect whenever filter values change
  useEffect(() => {
    let filtered = filteredData;
    filtered = filterByDay(filtered);
    filtered = filterByStatus(filtered);
    filtered = filterByModel(filtered);
    setFilteredData(filtered);
  }, [filterByDay, filterByStatus, filterByModel, filteredData]);

  const handleClear = () => {
    setFilterMonth("");
    setFilterDay("");
    setFilterStatusP("");
    setFilterModel("");
  };

  const handleMonthSelect = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    setFilteredData(filterDataByMonth(data, month)); // Update filtered data by month
  };
  const [isMobile, setIsMobile] = useState(false);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768); // Mobile if width <= 768px
  };

  useEffect(() => {
    handleResize(); // Check initially
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`; // Format as 'YYYY-MM-DD'
  };
  const [dropdownOpenReceiver, setDropdownOpenReceiver] = useState(null);
  const [dropdownOpenSeller, setDropdownOpenSeller] = useState(null);

  const dropdownRefReceiver = useRef(null);
  const dropdownRefSeller = useRef(null);

  const toggleDropdownReceiver = (index) => {
    setDropdownOpenReceiver(dropdownOpenReceiver === index ? null : index);
  };

  const toggleDropdownSeller = (index) => {
    setDropdownOpenSeller(dropdownOpenSeller === index ? null : index);
  };

  const handleOptionSelectReceiver = (index, itemId, receiver) => {
    setDropdownOpenReceiver(null); // Close the dropdown
    // Update the status in the frontend optimistically
    setData(
      data.map((item) =>
        item.ID === itemId ? { ...item, seller: receiver } : item
      )
    );
    // Update the status in the backend
    updateReceiver(itemId, receiver);
  };

  const handleOptionSelectSeller = (index, itemId, seller) => {
    setDropdownOpenSeller(null); // Close the dropdown
    // Update the status in the frontend optimistically
    setData(
      data.map((item) =>
        item.ID === itemId ? { ...item, seller: seller } : item
      )
    );
    // Update the status in the backend
    updateSeller(itemId, seller);
  };

  const updateReceiver = async (itemId, receiver) => {
    try {
      setLoading(true);
      await axios.put(
        `${apiUrl}/updateReceiver`,
        { id: itemId, receiver },
        {
          headers: {
            Authorization: `Bearer ${userId}`,
          },
        }
      );
      setLoading(false);
      // Fetch updated data after successful status update
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const updateSeller = async (itemId, seller) => {
    try {
      setLoading(true);
      await axios.put(
        `${apiUrl}/updateSeller`,
        { id: itemId, seller },
        {
          headers: {
            Authorization: `Bearer ${userId}`,
          },
        }
      );
      setLoading(false);
      // Fetch updated data after successful status update
      fetchData();
    } catch (error) {
      setLoading(false);
      setErrors(error.response?.data?.message || "An error occurred");
    }
  };

  const handlePostRow = async (item) => {
    try {
      const confirmPost = window.confirm(
        "Are you sure you want to POST this row?"
      );
      if (!confirmPost) {
        return; // Exit if user cancels
      }
      const userId = localStorage.getItem("token");
      const formData = new FormData();

      formData.append("orderNumber", item.OrderNumber || "");
      formData.append("brand", item.Brand || "");
      formData.append("model", item.Model || "");
      formData.append("sim", item.Sim || "");
      formData.append("ram", item.Ram || "");
      formData.append("storage", item.Storage || "");
      formData.append("status", item.Status || "");
      formData.append("delivery", item.DeliveryFee || "");
      formData.append("price", item.Price || "");
      formData.append("com1", item.com1 || "");
      formData.append("com2", item.com2 || "");
      formData.append("rate", item.rate || "");
      formData.append("carrier", item.carrier || "");
      formData.append("buyer", item.buyer || "");
      formData.append("seller", item.seller || "");
      formData.append("soldPrice", item.soldPrice || "");
      formData.append("receiver", item.receiver || "");
      formData.append("salesDate", item.salesDate || "");
      formData.append("buyRate", item.buyRate || "");
      formData.append("ourStat", item.ourStat || "");

      // Optional: If you want to send image files
      if (item.ImageFilename1) {
        // const image1 = await fetch(`${apiUrl}/uploads/${item.ImageFilename1}`)
        //   .then((r) => r.blob());
        formData.append("ImageFilename1", item.ImageFilename1);
      }

      if (item.ImageFilename2) {
        // const image2 = await fetch(`${apiUrl}/uploads/${item.ImageFilename2}`)
        //   .then((r) => r.blob());
        formData.append("ImageFilename2", item.ImageFilename2);
      }

      await axios.post(`${apiUrl}/adamaPost`, formData, {
        headers: {
          Authorization: `Bearer ${userId}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("✅ Row posted successfully!");
    } catch (error) {
      alert("Failed to post row.");
    }
  };

  const handleDeleteRow = async (orderNumber) => {
    try {
      const confirmPost = window.confirm(
        "Are you sure you want to DELETE this row?"
      );
      if (!confirmPost) {
        return; // Exit if user cancels
      }
      const userId = localStorage.getItem("token");

      await axios.delete(`${apiUrl}/delete/${orderNumber}`, {
        headers: {
          Authorization: `Bearer ${userId}`,
        },
      });

      alert("🗑 Row deleted successfully!");
      // Optional: remove from local state
      setData((prev) => prev.filter((row) => row.ID !== orderNumber));
    } catch (error) {
      alert("❌ Failed to delete row.");
      console.error(error);
    }
  };

  const totalExpense = filteredData.reduce(
    (acc, item) => acc + Number(item.Price || 0),
    0
  );
  // const totalCom1 = filteredData.reduce(
  //   (acc, item) => acc + Number(item.com1 || 0),
  //   0
  // );
  const totalCom1 = filteredData
    .filter((item) => Number(item.Price) > 0) // Exclude items with price 0
    .reduce((acc, item) => acc + Number(item.com1), 0);
  const totalCom2 = filteredData.reduce(
    (acc, item) => acc + Number(item.com2 || 0),
    0
  );
  const totalDelivery = filteredData.reduce(
    (acc, item) => acc + Number(item.DeliveryFee || 0),
    0
  );
  const phoneRef = useRef(null);
  const otherRef = useRef(null);
  const screenRef = useRef(null);
  const ethioRef = useRef(null);

  // const scrollToSection = (ref) => {
  //   ref.current?.scrollIntoView({ behavior: "smooth" });
  // };
  const scrollToSection = (ref, offset = 80) => {
    if (ref.current) {
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div>
      <Header />
      <Sidebar />
      <div className="items-center flex flex-col justify-center mt-2 md:mt-4 mb-5 w-full overflow-x-hidden">
        {loading ? (
          <div className="fixed top-14 md:top-16 left-1/2 transform -translate-x-1/2 z-50 bg-slate-900/90 backdrop-blur-sm text-white px-4 py-2 rounded-full shadow-xl text-xs font-semibold flex items-center gap-2 border border-slate-700">
            <span className="inline-block w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            Loading...
          </div>
        ) : null}

        {errors ? (
          <div className="fixed top-14 md:top-16 left-1/2 transform -translate-x-1/2 z-50 max-w-[92vw] md:max-w-lg bg-red-600 text-white px-4 py-2.5 rounded-xl shadow-2xl flex items-center justify-between gap-3 text-xs md:text-sm font-medium border border-red-400">
            <div className="flex items-center gap-2">
              <span className="text-base">⚠️</span>
              <span>{errors}</span>
            </div>
            <button
              onClick={() => setErrors(null)}
              className="text-white hover:text-red-200 text-sm font-bold ml-2 p-1 rounded hover:bg-red-700/50 transition-colors"
              title="Dismiss"
            >
              ✕
            </button>
          </div>
        ) : null}

        <div className="border-1 border-slate-200 mt-16 md:mt-20 w-full md:w-11/12 mb-20 px-2 md:px-5 rounded-md">
          <div className="flex flex-row justify-between items-center my-2 md:my-4 pb-2 md:pb-4 border-b border-gray-200">
            <h1 className="text-lg md:text-3xl font-bold text-gray-800">Products</h1>
          </div>

          {/* Fixed Category Navigation */}
          <div className="fixed left-12 md:left-5 top-[52px] md:top-32 z-[5] flex flex-row md:flex-col gap-1 md:gap-2">
            <button
              className="bg-blue-600 hover:bg-blue-700 active:scale-95 transition shadow-md font-medium text-white px-2 md:px-4 py-1 md:py-2 rounded-md text-[10px] md:text-sm whitespace-nowrap"
              onClick={() => scrollToSection(phoneRef, 300)}
            >
              📱 Phone
            </button>
            <button
              className="bg-red-500 hover:bg-red-600 active:scale-95 transition shadow-md font-medium text-white px-2 md:px-4 py-1 md:py-2 rounded-md text-[10px] md:text-sm whitespace-nowrap"
              onClick={() => scrollToSection(otherRef, 100)}
            >
              📦 Other
            </button>
            <button
              onClick={() => scrollToSection(screenRef, 100)}
              className="bg-emerald-500 hover:bg-emerald-600 active:scale-95 transition shadow-md font-medium text-white px-2 md:px-4 py-1 md:py-2 rounded-md text-[10px] md:text-sm whitespace-nowrap"
            >
              🖥 Screen
            </button>
            <button
              onClick={() => scrollToSection(ethioRef, 100)}
              className="bg-slate-800 hover:bg-slate-900 active:scale-95 transition shadow-md font-medium text-white px-2 md:px-4 py-1 md:py-2 rounded-md text-[10px] md:text-sm whitespace-nowrap"
            >
              🇪🇹 Ethio
            </button>
          </div>
          {isMobile ? (
            <div className="flex flex-col my-2 gap-2">
              {/* Month + Year row */}
              <div className="flex gap-2">
                <select
                  name="filterDay"
                  id="filterDayMobile"
                  className="border rounded-lg p-2 flex-1 text-sm bg-white shadow-sm"
                  value={selectedMonth}
                  onChange={(e) => filterByMonthAll(e.target.value)}
                >
                  <option value="" disabled>Month</option>
                  {months.map((month) => (
                    <option key={month} value={month}>{month}</option>
                  ))}
                  <option value="">All</option>
                </select>
                <div className="flex items-center gap-1 border rounded-lg p-2 bg-white shadow-sm flex-1">
                  <label htmlFor="year-select-mob" className="text-sm font-medium text-gray-600">Yr:</label>
                  <input
                    id="year-select-mob"
                    type="number"
                    value={selectedYear}
                    onChange={handleYearChange}
                    min="2000"
                    max={new Date().getFullYear()}
                    className="w-full text-sm outline-none"
                  />
                </div>
              </div>
              {/* Status + Sort row */}
              <div className="flex gap-2">
                <select
                  name="filterStatusP"
                  id="filterStatusPMobile"
                  className="border rounded-lg p-2 flex-1 text-sm bg-white shadow-sm"
                  value={filterStatusP}
                  onChange={(e) => setFilterStatusP(e.target.value)}
                >
                  <option value="__all__">All Status</option>
                  <option value="">Unreceived</option>
                  <option value="Received">Received</option>
                  <option value="Unpaid">Unpaid</option>
                  <option value="Sold">Sold</option>
                  <option value="Custom">Custom</option>
                  <option value="Repair">Repair</option>
                  <option value="Returned">Returned</option>
                </select>
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="border rounded-lg p-2 flex-1 text-sm bg-white shadow-sm"
                >
                  <option value="orderNumber">By Order#</option>
                  <option value="model">By Model</option>
                </select>
              </div>
              {/* Model search + clear */}
              <div className="flex gap-2">
                <input
                  className="border rounded-lg p-2 flex-1 text-sm bg-white shadow-sm"
                  type="text"
                  placeholder="Search by Model…"
                  value={filterModel}
                  onChange={(e) => setFilterModel(e.target.value)}
                />
                <button
                  onClick={handleClear}
                  className="bg-slate-600 hover:bg-slate-500 active:scale-95 text-white text-sm font-bold px-4 rounded-lg shadow-sm"
                >
                  Clear
                </button>
              </div>
            </div>
          ) : (
            <div className="flex flex-row m-2 p-2">
              <div className="w-3/4 mb-5">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="border rounded p-2"
                >
                  <option value="orderNumber">Sort by Order Number</option>
                  <option value="model">Sort by Model Name</option>
                </select>

                <select
                  name="filterDay"
                  id="filterDay"
                  className="border p-2 m-2"
                  value={selectedMonth}
                  onChange={(e) => filterByMonthAll(e.target.value)}
                >
                  <option value="" disabled>
                    Filter by Month
                  </option>
                  {months.map((month) => (
                    <option key={month} value={month}>
                      {month}
                    </option>
                  ))}
                  <option value="">All</option>
                </select>
                {/* <label htmlFor="month-select" className="font-bold mr-2">
                  Select Month:
                </label>
                <select
                  id="month-select"
                  onChange={handleMonthChange}
                  value={selectedMonth}
                >
                  <option value="">All</option>
                  <option value="Jan">January</option>
                  <option value="Feb">February</option>
                  <option value="Mar">March</option>
                  <option value="Apr">April</option>
                  <option value="May">May</option>
                  <option value="Jun">June</option>
                  <option value="Jul">July</option>
                  <option value="Aug">August</option>
                  <option value="Sep">September</option>
                  <option value="Oct">October</option>
                  <option value="Nov">November</option>
                  <option value="Dec">December</option>
                </select> */}
                <label htmlFor="year-select" className="mx-3 font-bold">
                  Year:
                </label>
                <input
                  id="year-select"
                  type="number"
                  value={selectedYear}
                  onChange={handleYearChange}
                  min="2000"
                  max={new Date().getFullYear()}
                />
              </div>
              <div className="w-3/4 mb-5 items-end justify-end self-end">
                <select
                  name="filterDay"
                  id="filterDay"
                  className="border p-2 m-2"
                  value={filterDay}
                  onChange={(e) => setFilterDay(e.target.value)}
                  disabled={!selectedMonth}
                >
                  <option value="" disabled>
                    Filter by Day
                  </option>
                  {selectedMonth &&
                    Array.from(
                      {
                        length: new Date(
                          new Date().getFullYear(),
                          months.indexOf(filterMonth) + 1,
                          0
                        ).getDate(),
                      },
                      (_, i) => i + 1
                    ).map((day) => (
                      <option key={day} value={day}>
                        {day}
                      </option>
                    ))}
                </select>
                <select
                  name="filterStatusP"
                  id="filterStatusP"
                  className="border p-2 m-2"
                  value={filterStatusP}
                  x
                  onChange={(e) => setFilterStatusP(e.target.value)}
                >
                  <option value="">Filter by Status</option>{" "}
                  {/* default placeholder */}
                  <option value="__unreceived__">Unreceived</option>
                  <option value="Received">Received</option>
                  <option value="Unpaid">Unpaid</option>
                  <option value="Sold">Sold</option>
                  <option value="Custom">Custom</option>
                </select>
                <input
                  type="text"
                  placeholder="Filtered by Model"
                  className="border p-2 m-2"
                  value={filterModel}
                  onChange={(e) => setFilterModel(e.target.value)}
                />
                <button
                  onClick={handleClear}
                  className="border p-2 m-2 bg-slate-500 hover:bg-slate-300 rounded"
                >
                  Clear
                </button>
                <button
                  onClick={() => window.location.href = '/scanner'}
                  className="border p-2 m-2 bg-blue-500 hover:bg-blue-300 rounded"
                >
                  Barcode Scan
                </button>
              </div>
            </div>
          )}
          {/* Month pill buttons — horizontal scroll on mobile */}
          <div className="flex overflow-x-auto gap-1.5 my-3 pb-1 md:justify-center md:flex-wrap md:gap-0">
            {months.map((month) => (
              <button
                key={month}
                onClick={() => filterByMonthAll(month)}
                className={`flex-shrink-0 px-3 md:px-4 py-1.5 md:py-2 rounded-full md:rounded-md mx-0.5 md:mx-2 text-xs md:text-sm font-medium transition-colors ${selectedMonth === month
                  ? "bg-blue-600 text-white shadow-md"
                  : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                  }`}
              >
                {month}
              </button>
            ))}
            <button
              onClick={() => filterByMonthAll("")}
              className={`flex-shrink-0 px-3 md:px-4 py-1.5 md:py-2 rounded-full md:rounded-md mx-0.5 md:mx-2 text-xs md:text-sm font-medium transition-colors ${selectedMonth === ""
                ? "bg-blue-600 text-white shadow-md"
                : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                }`}
            >
              All
            </button>
          </div>

          <div
            ref={phoneRef}
            className="relative max-h-[80vh] overflow-y-auto overflow-x-auto custom-scrollbar shadow-2xl rounded-2xl border border-slate-200 bg-white -mx-2 md:mx-0"
          >
            <table className="min-w-full text-xs md:text-sm text-left text-slate-700 whitespace-nowrap">
              <thead className="sticky top-0 bg-slate-800 text-white uppercase text-[10px] md:text-xs font-semibold tracking-wide md:tracking-widest shadow-md">
                <tr>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">#</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Brand</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Model</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Stor</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Ram</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Sim</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">¥Price</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Del</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">C1</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">C2</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-emerald-400">¥Tot</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Rate</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">BuyR</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Carr</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-blue-400">ETB</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-green-400">Profit</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-center">Img</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Buyer</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">SoldP</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-center">Seller</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-center">Recv</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-center">Status</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Bank</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Date</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700 text-center">Action</th>
                  <th className="px-2 md:px-4 py-2 md:py-4 z-1 border-b border-slate-700">Editor</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => {
                  const price = Number(item.Price) || 0;
                  const com1 = Number(item.com1) || 0;
                  const com2 = Number(item.com2) || 0;
                  const deliveryFee = Number(item.DeliveryFee) || 0;
                  const rate = Number(item.buyRate) || 0;
                  const carrier = Number(item.carrier) || 0;

                  const add = price + com1 + com2 + deliveryFee;
                  const yuan = Math.round(add * 10) / 10;

                  const birrRaw = add * rate + carrier;
                  const birr = Math.round(birrRaw * 100) / 100;

                  const profit =
                    Math.round((item.soldPrice - birr) * 100) / 100;

                  // ✅ accumulate ONCE
                  totalYuanSum += add;
                  totalBirrSum += birrRaw;
                  totalBirrCarrier += carrier;
                  totalProfit += profit;

                  return (
                    <tr key={item.ID} className="border-b-1 hover:bg-blue-50 transition-colors">
                      {isEditing === item.ID ? (
                        <>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.OrderNumber}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.brand !== undefined
                                  ? editData.brand
                                  : item.Brand
                              }
                              onChange={(e) =>
                                handleChange("brand", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.model !== undefined
                                  ? editData.model
                                  : item.Model
                              }
                              onChange={(e) =>
                                handleChange("model", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.storage !== undefined
                                  ? editData.storage
                                  : item.Storage
                              }
                              onChange={(e) =>
                                handleChange("storage", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.ram !== undefined
                                  ? editData.ram
                                  : item.Ram
                              }
                              onChange={(e) =>
                                handleChange("ram", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.sim !== undefined
                                  ? editData.sim
                                  : item.Sim
                              }
                              onChange={(e) =>
                                handleChange("sim", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.price !== undefined
                                  ? editData.price
                                  : item.Price
                              }
                              onChange={(e) =>
                                handleChange("price", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.delivery !== undefined
                                  ? editData.delivery
                                  : item.DeliveryFee
                              }
                              onChange={(e) =>
                                handleChange("delivery", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.com1 !== undefined
                                  ? editData.com1
                                  : item.com1
                              }
                              onChange={(e) =>
                                handleChange("com1", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.com2 !== undefined
                                  ? editData.com2
                                  : item.com2
                              }
                              onChange={(e) =>
                                handleChange("com2", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {yuan}
                          </td>

                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.rate !== undefined
                                  ? editData.rate
                                  : item.rate
                              }
                              onChange={(e) =>
                                handleChange("rate", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.buyRate !== undefined
                                  ? editData.buyRate
                                  : item.buyRate
                              }
                              onChange={(e) =>
                                handleChange("buyRate", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              value={
                                editData.carrier !== undefined
                                  ? editData.carrier
                                  : item.carrier
                              }
                              onChange={(e) =>
                                handleChange("carrier", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {birr}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {profit}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-700 bg-gray-100">
                            {item.ImageFilename1 !== "" ||
                              item.ImageFilename2 !== "" ? (
                              <div>
                                {/* Image upload inputs */}
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    setEditImage1(e.target.files[0])
                                  }
                                  accept="image/*"
                                />
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    setEditImage2(e.target.files[0])
                                  }
                                  accept="image/*"
                                />
                              </div>
                            ) : (
                              <div>
                                {/* Image upload inputs */}
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    setEditImage1(e.target.files[0])
                                  }
                                  accept="image/*"
                                />
                                <input
                                  type="file"
                                  onChange={(e) =>
                                    setEditImage2(e.target.files[0])
                                  }
                                  accept="image/*"
                                />
                              </div>
                            )}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              placeholder="buyer"
                              value={
                                editData.buyer !== undefined
                                  ? editData.buyer
                                  : item.buyer
                              }
                              onChange={(e) =>
                                handleChange("buyer", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              placeholder="price"
                              value={
                                editData.soldPrice !== undefined
                                  ? editData.soldPrice
                                  : item.soldPrice
                              }
                              onChange={(e) =>
                                handleChange("soldPrice", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <input
                              className="border w-full"
                              type="text"
                              placeholder="seller"
                              value={
                                editData.seller !== undefined
                                  ? editData.seller
                                  : item.seller
                              }
                              onChange={(e) =>
                                handleChange("seller", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              className="border w-full"
                              type="text"
                              placeholder="receiver"
                              value={
                                editData.receiver !== undefined
                                  ? editData.receiver
                                  : item.receiver
                              }
                              onChange={(e) =>
                                handleChange("receiver", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <div className="relative inline-block text-left">
                              <div className="flex flex-row justify-around">
                                <button
                                  type="button"
                                  className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-100  w-20 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-gray-50"
                                  id="menu-button"
                                  aria-expanded={dropdownOpen === index}
                                  aria-haspopup="true"
                                >
                                  {item.ourStat || "Options"}
                                </button>
                              </div>
                              {dropdownOpen === index && (
                                <div
                                  className="absolute right-0 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                  aria-orientation="vertical"
                                  aria-labelledby="menu-button"
                                  tabIndex="-1"
                                >
                                  <div className="py-1">
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Received"
                                        )
                                      }
                                    >
                                      Received
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Sent"
                                        )
                                      }
                                    >
                                      Sent
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Ren"
                                        )
                                      }
                                    >
                                      Returned
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {(editData.payments?.length
                              ? editData.payments
                              : initialData.payments || []
                            ).map((payment, index) => (
                              <div
                                key={index}
                                className="flex items-center gap-2"
                              >
                                {payment.type === "bank" ? (
                                  <>
                                    {/* Account select */}
                                    <select
                                      value={payment.account || ""}
                                      onChange={(e) =>
                                        handlePaymentChange(
                                          index,
                                          "account",
                                          e.target.value
                                        )
                                      }
                                      className="border rounded px-2 py-1 text-sm"
                                    >
                                      <option value="">Select Account</option>
                                      <option value="CBE-1277">
                                        CBE-1277 (Gelila)
                                      </option>
                                      <option value="CBE-2357">
                                        CBE-2357 (Yeabkal)
                                      </option>
                                      <option value="BOA-2848">
                                        BOA-2848: (Yeabkal)
                                      </option>
                                      <option value="DASHIN-1011">
                                        DASHIN-1011: (Yeabkal)
                                      </option>
                                      <option value="AWASH-2701">
                                        AWASH-2701: (Yeabkal)
                                      </option>
                                      <option value="TeleBirr-3333">
                                        TeleBirr-3333: (Yeabkal)
                                      </option>
                                      <option value="Cash">Cash</option>
                                    </select>

                                    {/* Amount input */}
                                    <input
                                      type="number"
                                      value={payment.amount || ""}
                                      onChange={(e) =>
                                        handlePaymentChange(
                                          index,
                                          "amount",
                                          e.target.value
                                        )
                                      }
                                      className="w-24 border rounded px-2 py-1 text-sm"
                                      placeholder="Amount"
                                    />
                                  </>
                                ) : (
                                  <>
                                    {/* Item description */}
                                    <input
                                      type="text"
                                      value={payment.description || ""}
                                      onChange={(e) =>
                                        handlePaymentChange(
                                          index,
                                          "description",
                                          e.target.value
                                        )
                                      }
                                      className="border rounded px-2 py-1 text-sm w-40"
                                      placeholder="Item Description"
                                    />

                                    {/* Item value */}
                                    <input
                                      type="number"
                                      value={payment.value || ""}
                                      onChange={(e) =>
                                        handlePaymentChange(
                                          index,
                                          "value",
                                          e.target.value
                                        )
                                      }
                                      className="w-24 border rounded px-2 py-1 text-sm"
                                      placeholder="Value"
                                    />
                                  </>
                                )}

                                {/* Remove */}
                                <button
                                  type="button"
                                  onClick={() => removePayment(index)}
                                  className="text-red-500 text-sm hover:underline"
                                >
                                  ✕
                                </button>
                              </div>
                            ))}

                            {/* Add buttons */}
                            <div className="flex gap-3 mt-2">
                              <button
                                type="button"
                                onClick={() => addPayment("bank")}
                                className="text-blue-600 text-sm font-medium hover:underline"
                              >
                                + Add Bank Payment
                              </button>
                              <button
                                type="button"
                                onClick={() => addPayment("item")}
                                className="text-green-600 text-sm font-medium hover:underline"
                              >
                                + Add Item Exchange
                              </button>
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <input
                              type="date"
                              placeholder={formatDate(item.salesDate)}
                              value={
                                editData.salesDate !== undefined
                                  ? editData.salesDate
                                  : item.salesDate
                              }
                              onChange={(e) =>
                                handleChange("salesDate", e.target.value)
                              }
                            />
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {loading ? (
                              <button className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-100  w-12 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-gray-50">
                                <Oval
                                  height={20}
                                  width={20}
                                  color="#fff"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  visible={true}
                                  ariaLabel="oval-loading"
                                  secondaryColor="#4fa94d"
                                  strokeWidth={2}
                                  strokeWidthSecondary={2}
                                />
                              </button>
                            ) : (
                              <button
                                className="inline-flex justify-around gap-x-1.5 rounded-md bg-gray-100  w-12 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-gray-50"
                                onClick={() => handleSave(item.ID)}
                              >
                                Save
                              </button>
                            )}
                            <button
                              className="inline-flex justify-around gap-x-1.5 rounded-md bg-red-500  w-12 mr-1 py-2 text-sm font-semibold text-blue-900 shadow-sm  hover:bg-red-300"
                              onClick={() => setIsEditing(null)}
                            >
                              Cancel
                            </button>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.editor_name}
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="border-b-1 pb-3 border-slate-600 text-left font-bold text-slate-800 m-0 bg-gray-100">
                            {item.OrderNumber}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.Brand}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.Model}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.Storage}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.Ram}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.Sim}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.Price}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.DeliveryFee}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.com1}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.com2}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {yuan}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.rate}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.buyRate}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.carrier}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {birr}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {profit}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-700 bg-gray-100 z-0">
                            {item.ImageFilename1 || item.ImageFilename2 ? (
                              <div className="flex flex-row gap-2 h-10">
                                {[item.imageUrl1, item.imageUrl2]
                                  .filter(Boolean)
                                  .map((img, index) => (
                                    <img
                                      key={index}
                                      src={img}
                                      alt=""
                                      height="20"
                                      width="20"
                                      className="cursor-pointer"
                                      onClick={() =>
                                        openModal(
                                          [
                                            item.imageUrl1,
                                            item.imageUrl2,
                                          ].filter(Boolean)
                                        )
                                      }
                                    />
                                  ))}
                              </div>
                            ) : (
                              <img
                                src={noImage}
                                alt="No Image Available"
                                height="10"
                                width="50"
                                className="cursor-pointer"
                                onClick={() => openModal([noImage])}
                              />
                            )}
                          </td>

                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            {item.buyer}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.soldPrice}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <div className="relative inline-block text-left">
                              <button
                                type="button"
                                className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.seller === ""
                                    ? "bg-black text-white"
                                    : ""
                                  }`}
                                id="menu-button-receiverr"
                                aria-expanded={dropdownOpenSeller === index}
                                onClick={() => toggleDropdownSeller(index)}
                              >
                                {item.seller || "select"}
                                <svg
                                  className="-mr-1 h-5 w-5 text-gray-400"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </button>
                              {dropdownOpenSeller === index && (
                                <div
                                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                  aria-orientation="vertical"
                                  aria-labelledby="menu-button-receiverr"
                                  tabIndex="-1"
                                >
                                  <div className="py-1" ref={dropdownRefSeller}>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectSeller(
                                          index,
                                          item.ID,
                                          "Yeabkal"
                                        )
                                      }
                                    >
                                      Yeabkal
                                    </button>

                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectSeller(
                                          index,
                                          item.ID,
                                          "Natnael"
                                        )
                                      }
                                    >
                                      Natnael
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectSeller(
                                          index,
                                          item.ID,
                                          "Yeabtsega"
                                        )
                                      }
                                    >
                                      Yeabtsega
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectSeller(
                                          index,
                                          item.ID,
                                          "Mihret"
                                        )
                                      }
                                    >
                                      Mihret
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            <div className="relative inline-block text-left">
                              <div className="flex flex-row justify-around">
                                <button
                                  type="button"
                                  className={`
                                  inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                  ${item.receiver === ""
                                      ? "bg-gray-500 text-white"
                                      : ""
                                    }`}
                                  id="menu-button-receiverr"
                                  aria-expanded={dropdownOpenReceiver === index}
                                  aria-haspopup="true"
                                  onClick={() => toggleDropdownReceiver(index)}
                                >
                                  {item.receiver || "select"}
                                  <svg
                                    className="-mr-1 h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                              {dropdownOpenReceiver === index && (
                                <div
                                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none "
                                  aria-orientation="vertical"
                                  aria-labelledby="menu-button-receiverr"
                                  tabIndex="-1"
                                >
                                  <div
                                    className="py-1"
                                    ref={dropdownRefReceiver}
                                  >
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectReceiver(
                                          index,
                                          item.ID,
                                          "Yeabkal"
                                        )
                                      }
                                    >
                                      Yeabkal
                                    </button>

                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectReceiver(
                                          index,
                                          item.ID,
                                          "Natnael"
                                        )
                                      }
                                    >
                                      Natnael
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelectReceiver(
                                          index,
                                          item.ID,
                                          "Yeabtsega"
                                        )
                                      }
                                    >
                                      Yeabtsega
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <div className="relative inline-block text-left">
                              <div className="flex flex-row justify-around">
                                <button
                                  type="button"
                                  className={`inline-flex justify-around gap-x-1.5 rounded-md w-20 mr-1 py-2 text-sm font-semibold shadow-sm hover:bg-gray-500
                                            ${item.ourStat === "Sold"
                                      ? "bg-green-500 text-white"
                                      : ""
                                    }
                                            ${item.ourStat === "Received"
                                      ? "bg-blue-500 text-white"
                                      : ""
                                    }
                                            ${item.ourStat === "Sent"
                                      ? "bg-yellow-500 text-white"
                                      : ""
                                    }
                                            ${item.ourStat === "Returned"
                                      ? "bg-purple-500 text-white"
                                      : ""
                                    }
                                            ${item.ourStat === "Unpaid"
                                      ? "bg-red-500 text-white"
                                      : ""
                                    }
                                            ${item.ourStat === "Custom"
                                      ? "bg-black text-white"
                                      : ""
                                    }
                                            ${!item.ourStat
                                      ? "bg-gray-100 text-blue-900"
                                      : ""
                                    }`}
                                  id="menu-button"
                                  aria-expanded={dropdownOpen === index}
                                  aria-haspopup="true"
                                  onClick={() => toggleDropdown(index)}
                                >
                                  {item.ourStat || "options"}
                                  <svg
                                    className="-mr-1 h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                              {dropdownOpen === index && (
                                <div
                                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                  aria-orientation="vertical"
                                  aria-labelledby="menu-button"
                                  tabIndex="-1"
                                >
                                  <div className="py-1">
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700 "
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Sold"
                                        )
                                      }
                                    >
                                      Sold
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Received"
                                        )
                                      }
                                    >
                                      Received
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Custom"
                                        )
                                      }
                                    >
                                      Custom
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Returned"
                                        )
                                      }
                                    >
                                      Returned
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Repair"
                                        )
                                      }
                                    >
                                      Repair
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Unpaid"
                                        )
                                      }
                                    >
                                      Unpaid
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Lost"
                                        )
                                      }
                                    >
                                      Lost
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(
                                          index,
                                          item.ID,
                                          "Unknown"
                                        )
                                      }
                                    >
                                      Unknown
                                    </button>
                                    <button
                                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                                      role="menuitem"
                                      tabIndex="-1"
                                      onClick={() =>
                                        handleOptionSelect(index, item.ID, "")
                                      }
                                    >
                                      clear
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.bankAcc}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {formatDate(item.salesDate)}
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-50">
                            <div className="flex flex-col gap-1 md:flex-row">
                              <button
                                className="inline-flex justify-center items-center rounded-md bg-gray-200 min-w-[44px] px-2 py-2 text-xs font-semibold text-blue-900 shadow-sm hover:bg-gray-300 active:scale-95 transition-transform"
                                onClick={() => handleEditClick(item)}
                              >
                                Edit
                              </button>
                              <button
                                className="inline-flex justify-center items-center rounded-md bg-red-200 min-w-[44px] px-2 py-2 text-xs font-semibold text-red-900 shadow-sm hover:bg-red-300 active:scale-95 transition-transform"
                                onClick={() => handleDeleteRow(item.OrderNumber)}
                              >
                                Del
                              </button>
                            </div>
                          </td>
                          <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                            {item.editor_name}
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
                <tr>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                    Total: {filteredData.length}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                    {totalExpense}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                    {totalDelivery}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                    {totalCom1}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                    {totalCom2}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200 font-bold">
                    {totalYuanSum}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                    -
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                    {totalBirrCarrier}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                    {totalBirrSum}
                  </td>
                  <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100 font-bold">
                    {totalProfit}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          ref={otherRef}
          className="mt-10 md:mt-20 justify-center align-center border-1 border-slate-200 w-full md:w-11/12 mb-20 min-h-screen px-2 md:px-5 rounded-md"
        >
          <OtherProducts />
        </div>
        <div
          ref={screenRef}
          className="mt-10 md:mt-20 justify-center align-center border-1 border-slate-200 w-full md:w-11/12 mb-20 min-h-screen px-2 md:px-5 rounded-md"
        >
          <ScreenAdmin />
        </div>
        <div
          ref={ethioRef}
          className="mt-10 md:mt-20 justify-center align-center border-1 border-slate-200 w-full md:w-11/12 mb-20 min-h-screen px-2 md:px-5 rounded-md"
        >
          <EthioProducts />
        </div>
        {/* Modal for full-screen display */}
        {showModal && (
          <div
            className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-10"
            onClick={closeModal} // Clicking the background closes the modal
          >
            <div
              className="rounded-lg shadow-lg max-w-lg relative bg-white p-2 pt-6"
              onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside modal
            >
              {/* Close Button */}
              <button
                className="absolute right-2 top-1 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                // className="bg-red-500 px-2  text-white rounded-md hover:bg-red-600"
                onClick={closeModal}
              >
                x
              </button>

              {/* Image */}
              <img
                src={images[currentIndex]}
                alt="Preview"
                className="max-w-full max-h-[80vh] rounded-lg transition-transform duration-200 cursor-pointer"
                style={{ transform: `scale(${zoom})` }}
                onWheel={(e) =>
                  setZoom((prev) =>
                    Math.min(Math.max(prev + e.deltaY * -0.001, 1), 3)
                  )
                }
              />

              {/* Right Arrow */}
              {images.length > 1 && (
                <button
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                  onClick={nextImage}
                >
                  ▶
                </button>
              )}
              {images.length > 1 && (
                <button
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white p-2 rounded-full"
                  onClick={prevImage}
                >
                  ◀
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Admin;
